import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { map, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import * as io from 'socket.io-client';
import { EfoEgiService } from './egi.service';
import { EfoSdbService } from './sdb.service';
import { AccessService } from '../../core/services/access.service';
import { SettingsService } from '../../core/services/settings.service';
import { EflowService } from './eflow.service';
import { ElevationService } from './elevation.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EfoElevateService {
  //private url = 'http://socket1.carbrewer.com:3002';
  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;
  private elevationUrl = environment.nestElevationApiUrl;

  private activeDealers$: BehaviorSubject<any> = new BehaviorSubject([]);
  public readonly activeDealers: Observable<any> =
    this.activeDealers$.asObservable();
  private selectedDealer$: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly selectedDealer: Observable<any> =
    this.selectedDealer$.asObservable();
  private activeAccounts$: BehaviorSubject<any> = new BehaviorSubject([]);
  public readonly activeAccounts: Observable<any> =
    this.activeAccounts$.asObservable();
  private selectedAccount$: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly selectedAccount: Observable<any> =
    this.selectedAccount$.asObservable();
  public account: any = {};
  private selectedCampaign$: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly selectedCampaign: Observable<any> =
    this.selectedCampaign$.asObservable();
  private accountCampaigns$: BehaviorSubject<any> = new BehaviorSubject([]);
  public readonly accountCampaigns: Observable<any> =
    this.accountCampaigns$.asObservable();
  public campaign: any = {};
  public dealer: any = {};
  private user: any;

  egiAccountInformation: any = [];

  public myAccountsNums: any[] = [];
  public myAccounts: any = [];
  private userSubscription$;

  constructor(
    private appSettings: SettingsService,
    private efoEgi: EfoEgiService,
    private efoSdb: EfoSdbService,
    private accessApi: AccessService,
    private efoEflow: EflowService,
    private elevationService: ElevationService,
    private http: HttpClient, // private errorHandlerService: ErrorHandlerService
  ) {
    this.userSubscription$ = this.accessApi.mee.subscribe((user) => {
      this.user = user;
      this.refreshAccounts();
    });

    this.selectedAccount$.subscribe((account) => {
      if (_.has(account, 'account_num')) {
        const { account_num } = account;
        this.account = account;
        this.getAccountCampaigns(account_num)
          .pipe(
            tap((rs) => {
              this.accountCampaigns$.next(rs);
              this.campaign = rs[0];
              this.selectedCampaign$.next(rs[0]);
              return [account_num, +rs[0].campaign_key];
            }),
          )
          .subscribe();
      }
    });

    this.selectedDealer$.subscribe((dealer) => {
      if (_.has(dealer, 'account_num')) {
        const { account_num } = dealer;
        this.dealer = dealer;
        this.getOmtCampaignListByAccount(account_num)
          .pipe(
            tap((rs) => {
              this.accountCampaigns$.next(rs);
              this.campaign = rs[0];
              this.selectedCampaign$.next(rs[0]);
              return [account_num, +rs[0].campaign_key];
            }),
          )
          .subscribe();
      }
    });
  }

  refreshAccounts(): void {
    this.efoEflow.getMyCustomers(this.user).subscribe((rs1) => {
      //this.getMyAccounts(this.user).subscribe((rs1) => {
      this.myAccounts = rs1.accounts;
      //this.myAccountsNums = _.map(rs1, 'edifice_acct');
      this.myAccountsNums = _.map(rs1, 'account_num');
      this.getActiveAccounts(true).subscribe();
      this.getActiveDealers(true).subscribe((rs) => {
        const settings = this.appSettings.get();
        if (_.has(settings, 'accountNum') && settings.accountNum.length > 1) {
          this.selectDealerByAccountNum(settings.accountNum);
        }
      });
    });
  }

  get(url, params = {}): Observable<any> {
    const queryString =
      url.indexOf('?') == -1 && !_.isEmpty(params)
        ? '?' + new URLSearchParams(params).toString()
        : '';
    return this.http.get(
      `${environment.nestElevationApiUrl}${url}${queryString}`,
    );
  }
  post(url, params = {}): Observable<any> {
    return this.http.post(`${environment.nestElevationApiUrl}${url}`, params);
  }
  put(url, params = {}): Observable<any> {
    return this.http.put(`${environment.nestElevationApiUrl}${url}`, params);
  }
  delete(url, params = {}): Observable<any> {
    return this.http.delete(`${environment.nestElevationApiUrl}${url}`, params);
  }

  selectAccount(account): void {
    this.selectedAccount$.next(account);
  }

  selectDealer(dealer): void {
    this.appSettings.set({ accountNum: dealer.account_num });
    this.selectedDealer$.next(dealer);
  }

  selectDealerByAccountNum(account_num): void {
    this.appSettings.set({ accountNum: account_num });
    const dealer = _.find(this.activeDealers$.getValue(), {
      account_num,
    });
    this.selectedDealer$.next(dealer);
  }

  selectCampaign(campaign): void {
    this.selectedCampaign$.next(campaign);
  }

  getMyAccounts(user): Observable<any> {
    return this.efoEgi.getData(
      '/elevate/getMyAccounts',
      _.pick(user, ['user_uuid', 'groups', 'user_info']),
    );
  }

  //not used right now.
  getMyAccount(user, options?): Observable<any> {
    options = _.pick(options, ['dealer_uuid', 'account_num']);
    return this.efoEgi.getData(
      '/elevate/getMyAccounts',
      _.extend(_.pick(user, ['user_uuid', 'groups', 'user_info']), options),
    );
  }

  getMyAdAccountIds(user): Observable<any> {
    return this.efoEgi.getData(
      '/elevate/getMyAdAccountIds',
      _.pick(user, ['user_uuid', 'groups', 'user_info']),
    );
  }
  getPreviousAccounts() {
    return this.elevationService.getData('/elevate/getPreviousAccounts');
  }

  getActiveAccounts(reload_flag?: boolean): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.activeAccounts$.getValue()) && !reload_flag) {
      return of(this.activeAccounts$.getValue()).pipe();
    } else {
      const params =
        this.accessApi.isInGroup('user', 'agent') ||
        this.accessApi.isInGroup('user', 'dealer') ||
        this.accessApi.isInGroup('user', 'oem')
          ? { account_num: this.myAccountsNums.join(',') }
          : {};
      return (
        this.post(`/elevate/getActiveAccounts`, params)

          //return this.efoEgi.getData('/elevate/getActiveAccounts', params)
          .pipe(
            map((rs) => {
              this.activeAccounts$.next(rs);
              return rs;
            }),
          )
      );
    }
  }

  getAccountCampaigns(account_num): Observable<any> {
    return this.post(`/elevate/getAccountCampaigns`, {
      account_num,
    });
  }

  getDealerCampaigns(account_num): Observable<any> {
    return this.post(`/elevate/getAccountCampaigns`, {
      account_num,
    });
  }

  getOmtCampaignListByAccount(account_num): Observable<any> {
    return this.post(`/omt/getOmtCampaignListByAccount`, {
      account_num,
    });
  }

  hubspotAccounts: any = [];

  //activeDealers: any = [];
  getActiveDealers(reload_flag?: boolean): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.activeDealers$.getValue()) && !reload_flag) {
      return of(this.activeDealers$.getValue()).pipe();
    } else {
      const params =
        this.accessApi.isInGroup('user', 'agent') ||
        this.accessApi.isInGroup('user', 'dealer') ||
        this.accessApi.isInGroup('user', 'oem')
          ? {
              is_active: 1,
              account_num: this.myAccountsNums.join(','),
            }
          : { is_active: 1 };
      //get All
      //const params =  (this.accessApi.isInGroup('user','agent') || this.accessApi.isInGroup('user','dealer') || this.accessApi.isInGroup('user','oem')) ? {is_active:1,account_num:this.myAccountsNums.join(',')}: {}
      //const params =  (this.accessApi.isInGroup('user','agent') || this.accessApi.isInGroup('user','dealer') || this.accessApi.isInGroup('user','oem')) ? {account_num:this.myAccountsNums.join(',')}: {}
      return this.efoSdb.getTypeLookups().pipe(
        switchMap((lookups) => {
          //return this.efoEgi.getData('/elevate/dealers', params).pipe(map(rs => {
          return this.elevationService
            .getData(
              '/access/getCurrentAuthorizedCustomers',
              {},
              { headers: this.accessApi.apiHeader },
            )
            .pipe(
              map((rs: any) => {
                rs = rs.accounts;
                _.each(rs, (d) => {
                  d.derived = {
                    status: d.is_active ? 'Active' : 'Cancelled',
                    dms:
                      !_.has(
                        d,
                        'dealer_info.egi.account_information.dmstype',
                      ) ||
                      !_.has(
                        lookups['dms'],
                        d.dealer_info.egi.account_information.dmstype,
                      )
                        ? 'N/A'
                        : lookups['dms'][
                            d.dealer_info.egi.account_information.dmstype
                          ].name,
                    data_source:
                      !_.has(
                        d,
                        'dealer_info.egi.account_information.data_source_type',
                      ) ||
                      !_.has(
                        lookups['data_source'],
                        d.dealer_info.egi.account_information.data_source_type,
                      )
                        ? 'N/A'
                        : lookups['data_source'][
                            d.dealer_info.egi.account_information
                              .data_source_type
                          ].name,
                  };
                });
                rs = _.sortBy(rs, 'dealer_name');
                this.activeDealers$.next(rs);
                //return this.activeDealers$.getValue();
                // this.activeDealers = rs;
                return rs;
              }),
            );
        }),
      );
    }
  }

  allDealers: any = [];

  getAllDealers(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.allDealers) && !reload_flag) {
      return of(this.allDealers).pipe();
    } else {
      return this.get(`/elevate/dealers`).pipe(
        map((rs) => {
          if (Array.isArray(rs)) {
            _.each(rs, (d) => {
              d.derived = {
                status: d.is_active ? 'Active' : 'Cancelled',
                //dms: (!_.has(d,'dealer_info.egi.account_information.dmstype') || !_.has(lookups['dms'],d.dealer_info.egi.account_information.dmstype))  ? 'N/A' : lookups['dms'][d.dealer_info.egi.account_information.dmstype].name,
                //data_source: (!_.has(d,'dealer_info.egi.account_information.data_source_type') || !_.has(lookups['data_source'],d.dealer_info.egi.account_information.data_source_type)) ? 'N/A' : lookups['data_source'][d.dealer_info.egi.account_information.data_source_type].name
              };
            });
            rs = _.sortBy(rs, 'dealer_name');
            this.allDealers = rs;
            return rs;
          }

          // If `rs` isn't an array, handle appropriately
          throw new Error('Unexpected response format. Expected an array.');
        }),
      );
    }
  }

  getCreativeDealers(): Observable<any> {
    return this.get('/fauxbox/getCreativeDealers', {});
  }

  getActiveDealer(account_num): Observable<any> {
    //return this.efoEgi.getData('/elevate/dealers', {account_num, is_active: 1})
    return this.efoEgi.getData('/elevate/dealers', {
      account_num,
      is_active: 1,
    });
  }

  getDealer(account_num, options?): Observable<any> {
    //return this.efoEgi.getData('/elevate/dealers', {account_num, is_active: 1})
    return this.get(`/elevate/dealer/${account_num}`);
  }

  getDealerInfo(account_num): Observable<any> {
    //return this.efoEgi.getData('/elevate/dealers', {account_num, is_active: 1})
    return this.getDealer(account_num).pipe(
      map((r) => {
        return r.dealer_info;
      }),
    );
  }

  findDealer(options): Observable<any> {
    //return this.efoEgi.getData('/elevate/dealers', {account_num, is_active: 1})
    return this.efoEgi.getData('/elevate/dealers', options);
  }

  getAllDealerData(options): Observable<any> {
    //return this.efoEgi.getData('/elevate/dealers', {account_num, is_active: 1})
    return this.findAllDealer(options).pipe(
      map((rs: any) => {
        return _.has(rs, 'data') ? rs.data : {};
      }),
    );
  }

  findAllDealer(options): Observable<any> {
    //return this.efoEgi.getData('/elevate/dealers', {account_num, is_active: 1})
    return this.http
      .post(`${environment.nestElevationApiUrl}/elevate/allDealers`, options)
      .pipe(
        map((rs: any) => {
          return _.has(rs, 'data[0]') ? rs.data[0] : {};
        }),
      );
  }

  getAllDealerWebCounts(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/getAllDealerWebCounts', {
      dealer_uuid,
    });
  }

  getAllDealerAudience(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/getAllDealerAudience', {
      dealer_uuid,
    });
  }

  setAllDealerProposal(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/setAllDealerProposal', {
      dealer_uuid,
    });
  }

  getAllDealersByLocation(options): Observable<any> {
    return this.efoEgi.getData('/elevate/getAllDealersByLocation', options);
  }

  getTable(table_name, options?): Observable<any> {
    options = _.isUndefined(options) ? {} : options;
    return this.post(`/elevate/getTable`, _.extend({ table_name }, options));
  }

  getHtml(url, selector?): Observable<any> {
    selector = _.isUndefined(selector) ? 'body' : selector;
    return this.post(`/elevate/getHtml`, {
      url,
      selector,
    });
  }

  //Creating a new dealer Stuff

  createDealerFromAllDealer(cbr_uuid): Observable<any> {
    return this.post(`/elevate/dealers/createNewDealersAndCampaign`, {
      cbr_uuid,
    });
  }

  setupNewDealerFbCatalog(account_num): Observable<any> {
    return this.efoEgi.getData('/elevate/setupNewDealerFbCatalog', {
      account_num,
    });
  }

  setupAllDealerFbCatalogAd(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/setupAllDealerFbCatalogAd', {
      dealer_uuid,
    });
  }

  setupAllDealerAdsetAudiences(options): Observable<any> {
    return this.efoEgi.getData(
      '/elevate/setupAllDealerAdsetAudiences',
      options,
    );
  }

  updateAllDealersAssessment(dealer_uuid, data): Observable<any> {
    return this.efoEgi.putData(
      `/elevate/allDealersAssessment/${dealer_uuid}`,
      data,
    );
  }
  getAllDealersAssessments(): Observable<any> {
    return this.get(`elevate/getAllDealersAssessments`);
  }

  vehicleExtractors(): Observable<any> {
    return this.efoEgi.getData('/elevate/vehicleExtractors', {});
  }

  websiteExtractors(options): Observable<any> {
    return this.efoEgi.getData('/elevate/websiteExtractors', options);
  }

  updateWebsiteExtractors(website_extractor): Observable<any> {
    return this.efoEgi.postData(
      '/elevate/websiteExtractors',
      website_extractor,
    );
  }

  campaigns(params): Observable<any> {
    const qs = new URLSearchParams(params).toString();

    return this.get(`/elevate/getCampaigns?${qs}`);
  }

  dealers(options): Observable<any> {
    return this.efoEgi.getData('/elevate/dealers', options);
  }

  //BrandMarketing Stuff
  brandMarketingFiles(): Observable<any> {
    return this.efoEgi.getData('/brandmarketing/listFtpFiles', {
      ftpuser: 'growpodium',
      dest_file: '/growpodium/brandmarketing',
    });
  }

  brandMarketingProcessFiles(): Observable<any> {
    return this.efoEgi.getData('/brandmarketing/getHoldingFiles', {});
  }

  processBreakdownFiles(): Observable<any> {
    return this.efoEgi.getData('/brandmarketing/processBreakdownFiles', {});
  }

  getInfutorCountsByDealer(
    account_num: String,
    distance?: number,
  ): Observable<any> {
    distance = _.isUndefined(distance) ? 15 : distance;
    return this.efoEgi.getData('/brandmarketing/getInfutorCountsByDealer', {
      account_num,
      distance: distance,
    });
  }

  getInfutorCountsByZipMakes(
    zip: String,
    makes: String[],
    distance?: number,
  ): Observable<any> {
    distance = _.isUndefined(distance) ? 15 : distance;
    return this.efoEgi.getData('/brandmarketing/getInfutorCountsByZipMakes', {
      zip: zip,
      makes: makes,
      distance: distance,
    });
  }

  getInfutorCountsByZipsMakes(
    zips: String[],
    makes: String[],
  ): Observable<any> {
    return this.efoEgi.getData('/brandmarketing/getInfutorCountsByZipsMakes', {
      zips: zips,
      makes: makes,
    });
  }

  getInfutorZipsRunningTotalByDistanceByDealer(
    account_num: String,
    distance?: number,
  ): Observable<any> {
    distance = _.isUndefined(distance) ? 30 : distance;
    return this.efoEgi.getData(
      '/brandmarketing/getInfutorZipsRunningTotalByDistanceByDealer',
      {
        account_num,
        distance: distance,
      },
    );
  }

  getDealerPopulationRunningTotal(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/getDealerPopulationRunningTotal', {
      dealer_uuid,
    });
  }

  getDealerCompetitorZipRankings(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/getDealerCompetitorZipRankings', {
      dealer_uuid,
    });
  }

  getDealerCompetitorZipRankingsSummary(
    cbr_uuid,
    distance = 20,
  ): Observable<any> {
    return this.elevationService.getData(
      '/elevate/getDealerCompetitorZipRankingsSummary',
      { cbr_uuid, distance },
    );
  }

  getDealerCompetitorZipWithDmsRankings(dealer_uuid): Observable<any> {
    return this.efoEgi.getData(
      '/elevate/getDealerCompetitorZipWithDmsRankings',
      { dealer_uuid },
    );
  }

  getDealerCompetitorZipRankingsWithDsmSummary(dealer_uuid): Observable<any> {
    return this.efoEgi.getData(
      '/elevate/getDealerCompetitorZipRankingsWithDsmSummary',
      { dealer_uuid },
    );
  }

  getDealerCompetitors(dealer_uuid): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/elevate/getDealerCompetitors`,
      {
        dealer_uuid,
      },
    );
  }

  syncAllDealers(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/syncAllDealers', {
      dealer_uuid,
    });
  }

  getMyVipCodesByBrands(user): Observable<any> {
    return this.efoEgi.getData(
      '/elevate/getMyVipCodesByBrands',
      _.pick(user, ['user_uuid', 'groups', 'user_info']),
    );
  }

  getMyCreativeDataByBrands(user): Observable<any> {
    return this.efoEgi.getData(
      '/elevate/getMyVipCodesByBrands',
      _.pick(user, ['user_uuid', 'groups', 'user_info']),
    );
  }

  //Reports Stuff
  getReports(params?): Observable<any> {
    params = _.extend({}, params);
    return this.efoEgi.getData('/elevate/getReports', params);
  }

  getReport(report_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/getReports', {
      report_uuid: report_uuid,
    });
  }

  getReportData(report_uuid): Observable<any> {
    const { campaign_key } = this.campaign;
    const { account_num } = this.dealer;
    return this.efoEgi.getData('/elevate/getReportData', {
      report_uuid,
      campaign_key,
      account_num,
    });
  }

  refreshReportData(report_uuid, params?): Observable<any> {
    const myParams = _.extend({ report_uuid: report_uuid }, params);
    const { campaign_key } = this.campaign;
    const { account_num } = this.dealer;
    return this.efoEgi.getData(
      '/elevate/refreshReportData',
      _.extend({ report_uuid, campaign_key, account_num }, params),
    );
  }

  upsertReport(report_uuid, data): Observable<any> {
    return this.efoEgi.postData('/elevate/report', {
      report_uuid: report_uuid,
      data: data,
    });
  }

  deleteReport(report_uuid, data): Observable<any> {
    return this.efoEgi.deleteData('/elevate/report', {
      report_uuid: report_uuid,
    });
  }

  //Materialized Views
  getMvLoadReport(): Observable<any> {
    return this.post(`/elevate/getMvLoadReport`, {});
  }

  getMvCampaignInfo(account_num?): Observable<any> {
    return this.post(`/elevate/getMvCampaignInfo`, { account_num });
  }

  getMvCampaignStats(days_offset?): Observable<any> {
    days_offset = _.isUndefined(days_offset) ? 10 : days_offset;
    return this.post(`/elevate/getMvCampaignStats`, {
      days_offset,
    });
  }

  getMvSalesSummary(account_num): Observable<any> {
    return this.post(`/elevate/getMvSalesSummary`, {
      account_num,
    });
  }

  getMvServiceSummary(account_num): Observable<any> {
    return this.post(`/elevate/getMvServiceSummary`, {
      account_num,
    });
  }

  getOnboarding(campaign_key): Observable<any> {
    return this.get(`/elevate/getOnboarding?campaign_key=${campaign_key}`);
  }

  getOnboardingAll(): Observable<any> {
    return this.get(`/elevate/getOnboardingAll`);
  }

  getDepartingAll(): Observable<any> {
    return this.get(`/elevate/getDepartingAll`);
  }
  getDeparting(campaign_key): Observable<any> {
    return this.get(`/elevate/getDeparting?campaign_key=${campaign_key}`);
  }

  updateOnboarding(pvars): Observable<any> {
    return this.post(`/elevate/updateOnboarding`, pvars);
  }
  getDealershipCounts(): Observable<any> {
    return this.get(`/elevate/dealers/getDealershipCounts`);
  }
  getDealershipCountsByOwner(): Observable<any> {
    return this.get(`/elevate/dealers/getDealershipCountsByOwner`);
  }
  getDealershipCountsByLocation(): Observable<any> {
    return this.get(`/elevate/dealers/getDealershipCountsByLocation`);
  }
  updateDeparting(pvars): Observable<any> {
    return this.post(`/elevate/updateDeparting`, pvars);
  }
  updateDealerIsActive(account_num, value) {
    return this.post(`/elevate/updateDealerIsActive`, {
      account_num,
      isActive: value,
    });
  }

  creativeSpecifics(pvars): Observable<any> {
    return this.post(`/elevate/creativeSpecifics`, pvars);
  }
  brandMarketShare(): Observable<any> {
    return this.efoEgi.getData('/elevation/cbr/oems', {}).pipe(
      map((rs) => {
        rs = _.sortBy(rs, 'make');
        return rs;
      }),
    );
  }

  public socketListen = () => {
    if (_.isUndefined(this.socket)) {
      this.socket = io(this.socketUrl, {
        transports: ['websocket'],
      });
      this.socket.on('connect', () => {
        this.socket.emit(
          'new-message',
          'portal service connected: elevate.service',
        );
      });
    }
    return new Observable((observer) => {
      this.socket.on('elevate', (data) => {
        observer.next(data);
      });
    });
  };
}
